/*
 * Swatch hover-preview.
 *
 * Existing ProductCardSwatches (in theme.js) swaps the card image when a
 * color swatch is CLICKED. This adds the parallel hover behavior:
 *   - mouseenter on a swatch → temporarily swap the card image to that
 *     variant's photo (preview)
 *   - mouseleave on the swatch (mouse moves elsewhere on the card or off) →
 *     revert the image to whatever was showing before the preview started
 *
 * Click still locks the selection through the existing class handler. We do
 * not touch the variant URL or the .js-active state — those are click-only.
 *
 * We need to play nicely when the user moves directly from one swatch to
 * another: that's a mouseenter on B without a meaningful mouseleave (the
 * leave from A fires too, but B's enter wins). We just take the latest enter
 * as the current preview, and only revert when the mouse leaves the WHOLE
 * swatches row.
 */
(function () {
  "use strict";

  function readCurrentImageState(img) {
    if (!img) return null;
    return {
      src: img.getAttribute("src"),
      srcset: img.getAttribute("srcset"),
      width: img.getAttribute("width"),
      height: img.getAttribute("height"),
    };
  }

  function applyImageState(img, state) {
    if (!img || !state) return;
    if (state.src != null) img.setAttribute("src", state.src);
    if (state.srcset != null) img.setAttribute("srcset", state.srcset);
    if (state.width != null) img.setAttribute("width", state.width);
    if (state.height != null) img.setAttribute("height", state.height);
  }

  function previewSwatch(card, swatchItem) {
    var img = card.querySelector(".js-img-grid");
    if (!img) return;

    var template = swatchItem.dataset.variantImage;
    var w = parseInt(swatchItem.dataset.variantImageWidth || "0", 10);
    var h = parseInt(swatchItem.dataset.variantImageHeight || "0", 10);
    if (!template || !w || !h) return;

    // Remember the state we started from so we can revert. Only capture on
    // the FIRST hover within a hover session — subsequent swatch-to-swatch
    // moves shouldn't overwrite the original.
    if (!card._previewBackup) {
      card._previewBackup = readCurrentImageState(img);
    }

    var src = template.replace("{width}", "300");
    var srcsetWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512];
    var srcset = srcsetWidths.reduce(function (acc, sw) {
      var sh = Math.floor((sw / w) * h);
      return acc + template.replace("{width}", String(sw)) + " " + sw + "w " + sh + "h, ";
    }, "");
    var height = Math.floor((300 / w) * h);

    img.setAttribute("src", src);
    img.setAttribute("srcset", srcset);
    img.setAttribute("width", "300");
    img.setAttribute("height", String(height));
  }

  function revertPreview(card) {
    if (!card._previewBackup) return;
    var img = card.querySelector(".js-img-grid");
    applyImageState(img, card._previewBackup);
    card._previewBackup = null;
  }

  function init() {
    document.addEventListener("mouseover", function (e) {
      var item = e.target.closest && e.target.closest(".js-product-swatch-item");
      if (!item) return;
      var card = item.closest(".js-product-card");
      if (!card) return;
      previewSwatch(card, item);
    });

    // Revert when the mouse leaves the swatches row entirely. Using mouseout
    // on the row container is more reliable than per-item mouseleave when
    // pills are tightly packed.
    document.addEventListener("mouseout", function (e) {
      var row = e.target.closest && e.target.closest("product-card-swatches, .product-card__swatch");
      if (!row) return;
      // relatedTarget is the element the mouse is moving INTO. If it's still
      // inside the row, ignore — we're just crossing internal boundaries.
      var to = e.relatedTarget;
      if (to && row.contains(to)) return;
      var card = row.closest(".js-product-card");
      if (!card) return;
      // If the user has CLICKED a swatch (the existing .js-active gets set
      // by theme.js), don't revert past their selection — clear our backup
      // so the next preview captures fresh state from the active swatch.
      var activeNow = card.querySelector(".js-product-swatch-item.js-active");
      if (activeNow) {
        card._previewBackup = null;
        return;
      }
      revertPreview(card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
